/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Row, Col, PaginationProps, Dropdown, Space, Spin } from 'antd';
import type { MenuProps } from 'antd';
import {
  Page,
  GridView,
  ListView,
  Pagination,
  Filter,
  Breadcrumb,
  Button,
  Dialog,
  SubDialog,
  ListCount,
  SearchBox,
  IconSwitcher,
  DeleteConfirmation,
  IngendientListDialog,
} from '../../components';
import RecipeActions from '../../redux/middleware/recipe';
import Attributes from '../../redux/middleware/attributes';
import { sortedData, sortNumber } from '../../helper/sortData';
import Fire from '../../assets/images/Fire.svg';
import More from '../../assets/images/More.png';
import Download from '../../assets/images/Download.svg';
import Delete from '../../assets/images/Delete.svg';
import Edit from '../../assets/images/Edit.png';
import Export from '../../assets/images/export.png';
import UpDownArrow from '../../assets/images/UpDownArrow.png';
import approved from '../../assets/images/approved.png';
import pending from '../../assets/images/pending.png';
import rejected from '../../assets/images/rejected.png';
import moment from 'moment';
import './styles.scss';
import { useSelector } from 'react-redux';
import Utils from '../../redux/utils';
const PageDataLength = [6, 10, 20];

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem('__chefAdminUser') || '');
  const [design, setDesign] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [openSubDialog, setOpenSubDialog] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState(0);
  const [current, setCurrent] = useState(1);
  const [sortData, setSortData] = useState([{}]);
  const [ascend, setAscend] = useState(true);
  const [dataLength, setDataLength] = useState(6);
  const [dialogData, setDialogData] = useState<any>({});
  const [total, setTotal] = useState(0);
  const [recipeLoader, setRecipeLoader] = useState(false);
  const [recipeCount, setRecipeCount] = useState(0);
  const [ingrdientCount, setIngredientCount] = useState(0);
  const [id, setId] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [data, setData] = useState<any>({});
  const [loader, setLoader] = useState(false);

  const { currentBrand } = useSelector((state: any) => state.Auth);

  // React.useEffect(() => {
  //   pageData();
  // }, [currentBrand]);

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: <div className="dotOption">Approval</div>,
      icon: <CheckCircleOutlined className="inventory-transfer-iconDropdown" />,
    },
    {
      key: '2',
      label: <div className="dotOption">Download</div>,
      icon: <img src={Download} width={15} />,
    },
    {
      key: '3',
      label: <div className="dotOption">Edit</div>,
      icon: <img src={Edit} />,
    },
    {
      type: 'divider',
    },
    {
      key: '4',
      label: <div className="dotOption deleteText">Delete</div>,
      icon: <img src={Delete} width={15} />,
    },
  ];

  const itemsForReadOnlyUsers: MenuProps['items'] = [
    {
      key: '2',
      label: <div className="dotOption">Download</div>,
      icon: <img src={Download} width={15} />,
    },
  ];
  const navigate = useNavigate();

  const [selectedRecipeId, setSelectedRecipeId] = useState('');
  const handleSort = (column: string, type: string) => {
    let arr =
      type == 'string'
        ? sortedData(ascend, sortData, column)
        : sortNumber(ascend, sortData, column);
    setSortData(() => arr);
  };
  const setSelectedMenu = (recipe: any) => {
    setDialogData(recipe);
    setSelectedRecipeId(recipe.rb_id);
  };

  const UTCtoLocal = (utcDate: any) => {
    var stillUtc = moment.utc(utcDate).toDate();
    var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    return local;
  };

  const handleClose = () => {
    setDialog(false);
  };

  // const data = {
  //   ingredients: [
  //     {
  //       id: 'RB23452354590',
  //       value: 23,
  //       unit: 'grams',
  //       inventory_name: 'Almond',
  //       rb_inventory: 'TBH Almond',
  //       is_match: false,
  //     },
  //     {
  //       id: 'RB256477235343',
  //       value: 89,
  //       unit: 'piece',
  //       inventory_name: 'Butter',
  //       rb_inventory: 'TBH Butter',
  //       is_match: true,
  //     },
  //   ],
  //   permissions: [
  //     {
  //       permission: 'CAL',
  //       perm_status_id: 2,
  //       perm_create: 0,
  //       value: 23.4,
  //       value_tbh: 65.3,
  //     },
  //     {
  //       permission: 'PRO',
  //       perm_status_id: 1,
  //       perm_create: 0,
  //       value: 50.32,
  //       value_tbh: 23.3,
  //     },
  //     {
  //       permission: 'FATS',
  //       perm_status_id: 2,
  //       perm_create: 1,
  //       value: 21.9,
  //       value_tbh: 32.5,
  //     },
  //     {
  //       permission: 'CARB',
  //       perm_status_id: 2,
  //       perm_create: 1,
  //       value: 43.02,
  //       value_tbh: 32.67,
  //     },
  //   ],
  //   allergens: [
  //     {
  //       name: 'Milk',
  //       own_created: 1,
  //       is_inventory: false,
  //       is_rbInventory: true,
  //       verified: 0,
  //     },
  //     {
  //       name: 'Egg',
  //       own_created: 0,
  //       is_inventory: false,
  //       is_rbInventory: true,
  //       verified: 1,
  //     },
  //     {
  //       name: 'Fish',
  //       own_created: 1,
  //       is_inventory: false,
  //       is_rbInventory: false,
  //       verified: 1,
  //     },
  //     {
  //       name: 'ShellFish',
  //       own_created: 0,
  //       is_inventory: true,
  //       is_rbInventory: false,
  //       verified: 1,
  //     },
  //     {
  //       name: 'Treenuts',
  //       own_created: 1,
  //       is_inventory: true,
  //       is_rbInventory: true,
  //       verified: 1,
  //     },
  //     {
  //       name: 'Peanuts',
  //       own_created: 1,
  //       is_inventory: false,
  //       is_rbInventory: true,
  //       verified: 1,
  //     },
  //     {
  //       name: 'Soybean',
  //       own_created: 1,
  //       is_inventory: false,
  //       is_rbInventory: true,
  //       verified: 1,
  //     },
  //     {
  //       name: 'Gluten',
  //       own_created: 0,
  //       is_inventory: true,
  //       is_rbInventory: true,
  //       verified: 1,
  //     },
  //   ],
  // };

  const columns = [
    {
      title: () => (
        <div className="tableTitle">
          <span>RECIPE NAME</span>
          <img
            src={UpDownArrow}
            className="titleArrow"
            onClick={() => {
              handleSort('recipe_name', 'string');
              setAscend(!ascend);
            }}
          />
        </div>
      ),
      dataIndex: 'recipe',
      key: 'recipe',
      responsive: ['md'],
      render: (data: any, record: any) => {
        return (
          <div className="col1 font">
            <img src={record?.thumbnail} width="52px" height="52px" />
            <div className="subCol1 font">
              <div
                className="col1Text font table-title1-hover"
                onClick={() => {
                  handleingredient(record);
                }}
              >
                {record?.recipe_name}
              </div>

              <div className="subTextCol1 font">
                {record?.is_verified ? (
                  <img
                    src={Fire}
                    width={15}
                    alt=""
                    className=" iconFireWhite"
                  />
                ) : (
                  <img src={Fire} width={15} alt="" className="subCol1Icon" />
                )}

                <span className="col1Text font">{record?.calorie}</span>
                <span className="calories font ">kcal</span>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: () => (
        <div className="tableTitle">
          <span>MENU CATEGORY</span>

          <img
            src={UpDownArrow}
            className="titleArrow"
            onClick={() => {
              handleSort('category_name', 'string');
              setAscend(!ascend);
            }}
          />
        </div>
      ),
      dataIndex: 'category',
      key: 'category',
      responsive: ['md'],
      render: (data: any, record: any) => (
        <div className="recipe-builder-col2">{record?.category_name}</div>
      ),
    },
    {
      title: () => (
        <div className="tableTitle">
          <span>SUB COUNT</span>

          <img
            src={UpDownArrow}
            className="titleArrow"
            onClick={() => {
              handleSort('sub_recipe_items', 'number');
              setAscend(!ascend);
            }}
          />
        </div>
      ),
      dataIndex: 'sub_recipe',
      key: 'sub_recipe',
      responsive: ['md'],
      render: (data: any, record: any) => (
        <div className="col3">
          {record?.sub_recipe_items}{' '}
          {+record?.sub_recipe_items > 1 ? 'items' : 'item'}
        </div>
      ),
    },
    {
      title: () => (
        <div className="tableTitle">
          <span>STATUS</span>

          <img
            src={UpDownArrow}
            className="titleArrow"
            onClick={() => {
              handleSort('servings', 'number');
              setAscend(!ascend);
            }}
          />
        </div>
      ),
      dataIndex: 'servings',
      key: 'servings',
      responsive: ['md'],
      render: (data: any, record: any) => (
        // <div className="col3">{record?.servings + ' items'}</div>
        // <div>
        //   {record?.status == 0 ? (
        //     <img className="rd-approveIcon" src={pending} />
        //   ) : record?.status == 1 ? (
        //     <img className="rd-rejectIcon" src={rejected} />
        //   ) : (
        //     <img className="rd-approveIcon" src={approved} />
        //   )}
        // </div>
        <div
          className={`requestStatusContainer ${
            record?.status_type?.toLowerCase() == 'pending'
              ? 'inventoryTransfer-request-pending'
              : record?.status_type?.toLowerCase() == 'approved'
              ? 'inventoryTransfer-request-approve'
              : 'inventoryTransfer-request-reject'
          } `}
        >
          {record?.status_type}
        </div>
      ),
    },

    {
      title: () => (
        <div className="tableTitle">
          <span>CREATED AT</span>

          <img
            src={UpDownArrow}
            className="titleArrow"
            onClick={() => {
              handleSort('created_at', 'string');
              setAscend(!ascend);
            }}
          />
        </div>
      ),
      dataIndex: 'created_at',
      key: 'created_at',
      responsive: ['md'],
      render: (data: any, record: any) => (
        <div className="col3 col4">
          {moment(UTCtoLocal(record?.created_at)).fromNow()}
        </div>
      ),
    },
    {
      title: '',
      dataIndex: 'created_at',
      key: 'created_at',
      responsive: ['md'],
      render: (data: any, record: any) => (
        <Dropdown
          menu={{
            items:
              permissionStatus && permissionStatus === 2
                ? record?.status == 0
                  ? items
                  : items?.filter((item: any) => +item?.key != 1)
                : itemsForReadOnlyUsers,
            onClick: handleDropDownClick,
          }}
          trigger={['click']}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <a onClick={() => setSelectedMenu(record)}>
            <Space>
              <div className="dots">
                <img src={More} />
              </div>
            </Space>
          </a>
        </Dropdown>
      ),
    },
  ];
  useEffect(() => {
    let permissions = user?.permissions;
    const data = permissions.filter(
      (permission: any) => permission?.permission === 'R&D Recipe List'
    );
    setPermissionStatus(data[0]?.perm_status_id);
    setCurrent(1);
  }, []);

  useEffect(() => {
    if (dataLength && current) {
      pageData();
    }
  }, [dataLength, current, currentBrand]);

  const item1: MenuProps['items'] = PageDataLength.map((data, index) => {
    return {
      key: `${index}`,
      label: <div className="font dotOption">{data}</div>,
    };
  });

  const handleMenuClick: MenuProps['onClick'] = (e: any) => {
    setDataLength(PageDataLength[+e?.key]);
  };

  const handleingredient = async (data: any) => {
    const details = await RecipeActions.getDetailRecipe(data?.rb_id);
    setDialogData(details);
    setOpenDialog(true);
  };

  const menuProps = {
    items: item1,
    onClick: handleMenuClick,
  };

  const onChange: PaginationProps['onChange'] = (page) => {
    setCurrent(page);
  };

  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleDropDownClick: MenuProps['onClick'] = async (e: any) => {
    let option = +e.key;
    if (option == 1) {
      const { data } = await RecipeActions.getApprovalById(selectedRecipeId);
      setData(data);
      if (data) {
        setDialog(true);
      }
    }

    if (option == 2) {
      setLoader(true);
      const { data, success } = await RecipeActions.getRecipeLink(
        selectedRecipeId
      );
      setLoader(false);
      if (success) {
        // setPdf(data);
        openInNewTab(data);
      }
    }
    switch (option) {
      case 3:
        navigate('wizard', { state: { update: true, id: selectedRecipeId } });
        break;
      case 4:
        setOpenDeleteDialog(true);
        break;
      default:
    }
  };

  const handleDeleteCancel = () => {
    setOpenDeleteDialog(false);
  };
  const handleDeleteContinue = async () => {
    setOpenDeleteDialog(false);
    selectedRecipeId.length &&
      (await RecipeActions.delRecipe(selectedRecipeId));
    pageData();
  };

  const DropDownmenuProps = {
    items:
      permissionStatus && permissionStatus === 2
        ? items
        : itemsForReadOnlyUsers,
    onClick: handleDropDownClick,
  };

  const DropDownMenuWithoutApprovalProps = {
    items:
      permissionStatus && permissionStatus === 2
        ? items?.filter((item: any) => +item?.key != 1)
        : itemsForReadOnlyUsers,
    onClick: handleDropDownClick,
  };

  const pageData = async () => {
    const brand = await Utils.getCurrentBrand();
    setRecipeLoader(true);
    const recipeData = await RecipeActions.getRecipes(
      dataLength,
      current,
      currentBrand?.brand_id || brand?.brand_id,
      1
    );

    if (recipeData == undefined || !recipeData?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      setRecipeCount(recipeData?.data?.recipe_count);
      setIngredientCount(recipeData?.data?.ingredients_count);
      setTotal(recipeData?.data?.pagination?.total);
      setSortData(recipeData?.data?.items);
    }
    setRecipeLoader(false);
  };

  const pageDataFilter = async (filters: any) => {
    console.log('filters', filters);
    setRecipeLoader(true);
    const brand = await Utils.getCurrentBrand();

    const recipeData = await RecipeActions.recipesFilters(
      dataLength,
      current,
      filters,
      currentBrand?.brand_id || brand?.brand_id
    );

    if (recipeData == undefined || !recipeData?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      setRecipeCount(recipeData?.data?.recipe_count);
      setIngredientCount(recipeData?.data?.ingredients_count);
      setTotal(recipeData?.data?.pagination?.total);
      setSortData(recipeData?.data?.items);
    }

    setRecipeLoader(false);
  };

  const actionButton = (
    <Button
      text="Add New"
      className="theme-button recipeBtn"
      icon={<PlusOutlined />}
      handleButtonClick={() => {
        navigate('wizard', { state: { update: false, id: '' } });
      }}
      shape="round"
      size="middle"
    />
  );

  const onSearch = async (keyword: string) => {
    setRecipeLoader(true);
    const searchResultofRecipes = await RecipeActions.searchRecipe(
      dataLength,
      current,
      keyword
    );
    if (searchResultofRecipes == undefined || !searchResultofRecipes?.success) {
      setRecipeCount(0);
      setIngredientCount(0);
      setTotal(0);
      setSortData([]);
    } else {
      setRecipeCount(searchResultofRecipes?.data?.recipe_count);
      setIngredientCount(searchResultofRecipes?.data?.ingredients_count);
      setTotal(searchResultofRecipes?.data?.pagination?.total);
      setSortData(searchResultofRecipes?.data?.items);
    }

    setRecipeLoader(false);
  };

  const handleCSV = async () => {
    const response = await Attributes.exportCSV('Recipes');
    console.log('response', response);
    const { data } = response;
    window.open(data?.url);
  };

  const handleMarkRecipe = async (payload: any, recipe_id: any) => {
    setLoader(true);
    const response = await RecipeActions.markRecipe(payload, recipe_id);
    setLoader(false);
    if (response?.success) {
      setDialog(false);
      pageData();
    }
  };

  return (
    <div className="recipeBuilderPage">
      <Dialog
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        handleSubDialog={(id: any) => {
          setOpenDialog(false);
          setOpenSubDialog(true);
          setId(id);
        }}
        printApi={RecipeActions}
        data={dialogData}
        component={'RecipeBuilder'}
      />
      <SubDialog
        open={openSubDialog}
        data={id}
        handleSubDialog={() => {
          setOpenSubDialog(false);
          setOpenDialog(true);
        }}
        component={'RecipeBuilder'}
        handleCloseAll={() => {
          setOpenSubDialog(false);
          setOpenDialog(false);
        }}
      />
      {dialog && (
        <IngendientListDialog
          open={dialog}
          handleClose={handleClose}
          data={data}
          handleMarkRecipe={handleMarkRecipe}
          loader={loader}
          component={'r&d_recipe'}
        />
      )}
      <DeleteConfirmation
        handleDeleteCancel={handleDeleteCancel}
        handleDeleteContinue={handleDeleteContinue}
        open={openDeleteDialog}
        message={`Are you sure want to delete ${dialogData?.recipe_name}?`}
      />

      <Breadcrumb
        handleCSV={handleCSV}
        heading="R&D Recipe List"
        breadcrumbIcon
        iconAction={() => {
          navigate('/app/Dashboard');
        }}
        button={actionButton}
        perm_status={permissionStatus}
      />
      <Spin spinning={loader} size="large">
        <Page title="Dashboard">
          <Row className="listingTopFilter">
            <Col md={24} lg={12}>
              <ListCount
                count1={recipeCount}
                title1="Total Recipes"
                count2={ingrdientCount}
                title2="Total Ingredients"
              />
            </Col>
            <Col md={24} lg={12}>
              <div className="search-wrapper">
                <SearchBox action={onSearch} placeholderText="Search..." />
                <div className="exportButton" onClick={handleCSV}>
                  <img src={Export} alt="" />
                  <div className="exportText"> Export CSV</div>
                </div>

                <IconSwitcher listViewLayout={design} setListView={setDesign} />
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={6} md={8}>
              <Filter
                action={pageDataFilter}
                apiCall={RecipeActions.getRecipesFilters}
              />
            </Col>
            <Col lg={18} md={16}>
              {!design && !recipeLoader ? (
                <GridView
                  handledata={''}
                  DropDownmenuProps={DropDownmenuProps}
                  DropDownMenuWithoutApprovalProps={
                    DropDownMenuWithoutApprovalProps
                  }
                  setSelectedMenu={setSelectedMenu}
                  dataSource={sortData || []}
                  component={'recipeBuilder'}
                  handleDialog={''}
                  handleOpen={(data: any) => {
                    handleingredient(data);
                  }}
                  UTCtoLocal={UTCtoLocal}
                />
              ) : (
                !design && (
                  <div className="loader-wrapper">
                    <Spin spinning={recipeLoader} className="recipeLoader" />
                  </div>
                )
              )}

              {design && !recipeLoader ? (
                <ListView
                  limit={dataLength}
                  items={items}
                  dataSource={[...sortData] || []}
                  columns={columns}
                  component={'recipe builder'}
                />
              ) : (
                design && (
                  <div className="loader-wrapper">
                    <Spin spinning={recipeLoader} className="recipeLoader" />
                  </div>
                )
              )}
              <Pagination
                total={total}
                menuProps={menuProps}
                onChange={onChange}
                current={current}
                dataLength={dataLength >= total ? total : dataLength}
                handleLength={(data: number) => setDataLength(data)}
              />
            </Col>
          </Row>
        </Page>
      </Spin>
    </div>
  );
};

export default Dashboard;
